"use client";
import { jsx as t } from "react/jsx-runtime";
import { createContext as i, useContext as l } from "react";
import { useInkeepIntelligentForm as m } from "./use-inkeep-intelligent-form.js";
import { InkeepConversationProvider as s } from "../../providers/conversation-provider.js";
import { ChatEventsProviderWithBase as c } from "../../providers/chat-events-provider.js";
const r = i(void 0), u = ({
  children: e,
  formSettings: o
}) => {
  const n = m({ formSettings: o });
  return /* @__PURE__ */ t(r.Provider, { value: n, children: e });
}, F = (e) => /* @__PURE__ */ t(s, { children: /* @__PURE__ */ t(c, { children: /* @__PURE__ */ t(u, { ...e }) }) }), a = () => {
  const e = l(r);
  if (!e)
    throw new Error("useIntelligentForm must be used within a IntelligentFormProvider");
  return e;
};
export {
  F as IntelligentFormProvider,
  u as IntelligentFormProviderImpl,
  a as useIntelligentForm
};
